import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material'
import useColorSchemeListener from '../hooks/useColorSchemeListener'
import globalStyles from '../globalStyles'
import ThemeIcon from './ThemeIcon'
import theme from '../theme'
import React from 'react'

export interface Props {
  children: React.ReactNode
}

export default function ThemeWrapper({ children }: Readonly<Props>) {
  useColorSchemeListener()
  return (
    <ThemeProvider theme={theme}>
      <ThemeIcon>
        <CssBaseline />
        <GlobalStyles styles={globalStyles} />
        {children}
      </ThemeIcon>
    </ThemeProvider>
  )
}
